import { GENRES as GENRES_ENUM, VERTICALS as VERTICALS_ENUM } from './enums';

export const GENRE_CATEGORIES = {
  [VERTICALS_ENUM.AUDIOBOOKS]: [
    GENRES_ENUM.FICTION,
    GENRES_ENUM.FANTASY,
    GENRES_ENUM.NON_FICTION,
    GENRES_ENUM.KIDS,
    GENRES_ENUM.YOUNG_ADULT,
    GENRES_ENUM.BIOGRAPHY_MEMOIR,
    GENRES_ENUM.BUSINESS,
    GENRES_ENUM.COMEDY,
    GENRES_ENUM.FANTASY,
    GENRES_ENUM.HEALTH_FITNESS,
    GENRES_ENUM.HISTORY,
    GENRES_ENUM.HORROR,
    GENRES_ENUM.LIT_FICTION,
    GENRES_ENUM.MYSTERIES_THRILLERS,
    GENRES_ENUM.RELIGION_SPIRITUALITY,
    GENRES_ENUM.ROMANCE,
    GENRES_ENUM.SCIENCE_TECHNOLOGY,
    GENRES_ENUM.SCI_FI,
    GENRES_ENUM.SELF_DEVELOPMENT,
    GENRES_ENUM.SPORTS,
    GENRES_ENUM.TRAVEL,
  ],
  [VERTICALS_ENUM.VIDEOGAMES]: [
    GENRES_ENUM.ACTION,
    GENRES_ENUM.ADVENTURE,
    GENRES_ENUM.FIGHTING,
    GENRES_ENUM.PUZZLE,
    GENRES_ENUM.RACING,
    GENRES_ENUM.ROLE_PLAYING,
    GENRES_ENUM.SHOOTER,
    GENRES_ENUM.SIMULATION,
    GENRES_ENUM.SPORTS,
    GENRES_ENUM.STRATEGY,
    GENRES_ENUM.MISC,
  ],
};
